import { PartnerAggregateTab, type PartnerAggregateConfig } from '@/components/PartnerAggregateTab'

const CONFIG: PartnerAggregateConfig = {
  entityShort: '입고',
  entityLabel: '매입처',
  entityNo: '입고번호',
  searchPlaceholder: '품목·입고번호 검색',
  partnerFilterPlaceholder: '전체 매입처',
  emptyDetailText: '이 매입처의 입고 라인이 없습니다.',

  summaryApi: '/api/receiving/partner-summary',
  summaryExportApi: '/api/receiving/partner-summary/export',
  detailExportApi: '/api/receiving/partner-detail/export',
  detailApi: '/api/receiving/lines',
  queryKeyPrefix: 'rcv-partner-summary',
  excelFilePrefix: '입고현황_매입처별',

  linkPath: '/main/receiving',
  partnerBizClass: 'vendor',
}

export function ReceivingByPartnerTab() {
  return <PartnerAggregateTab config={CONFIG} />
}
